module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/A4Xyec/tc-custom/9781460303559.jpg?1705022405115",
      "alt": "This image is the cover for the book No More Sweet Surrender, Scandal in the Spotlight"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No More Sweet Surrender, Scandal in the Spotlight\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Ivan Korovin is determined to cement his evolution from dirt-poor, dreamless kid to billionaire philanthropist. First he has a serious PR problem to take care of: outspoken Miranda Sweet has ruined his repuation by labeling him “Caveman #1” in her bestselling book."), _c('br'), _c('br'), _vm._v("The solution? Give the ravenous public what they wantto see the enemies become lovers! From the red carpet in L.A. to black-tie charity balls in Moscow, they play out their pretend love story for all the world to see. But beneath the glare of the spotlight, it’s getting harder to tell what’s real and what’s for show.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Caitlin Crews\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Caitlin Crews discovered her first romance novel at the age of twelve and has since began her life-long love affair with romance novels, many of which she insists on keeping near her at all times. She currently lives in California, with her animator/comic book artist husband and their menagerie of ridiculous animals.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0